import {
  FormInput,
  SwitchInput,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TIServiceForm } from "./iServiceSchema";
import { iServiceTypeList } from "../../../../../services/iServiceType.service";
import { IIServiceType } from "../../../../../models/i-service-type";
import { Box, Grid, Typography } from "@mui/material";
import { MethodType } from "./MethodType";
import { BusInternalTokenWrapper } from "./IServiceType/BusInternalToken/BusInternalTokenWrapper";
import { SI_PNIWrapper } from "./IServiceType/SI_PNI/SI_PNIWrapper";
import { CertillionWrapper } from "./IServiceType/Certillion/CertillionWrapper";
import { GerAcessoWrapper } from "./IServiceType/GerAcesso/GerAcessoWrapper";
import { PlugNotasWrapper } from "./IServiceType/PlugNotas/PlugNotasWrapper";
import { ShiftLISWrapper } from "./IServiceType/ShiftLIS/ShiftLISWrapper";
import { ProtheusWrapper } from "./IServiceType/Protheus/ProtheusWrapper";
import { SGUWrapper } from "./IServiceType/SGU/SGUWrapper";

const translationPath = "page.4uBus.register.iService.";

export const IServiceFields = memo(() => {
  const { t } = useTranslation();

  const { formState } = useFormContext<TIServiceForm>();

  const { sendRequest: requestIServiceTypeList } = useFetch(iServiceTypeList);

  const [iServiceTypes, setIServiceTypes] = useState<IIServiceType[]>([]);

  const fetchIServiceTypeList = useCallback(async () => {
    const { data, success } = await requestIServiceTypeList(null);
    if (data && success) {
      setIServiceTypes(data);
    }
  }, [requestIServiceTypeList]);

  useEffect(() => {
    fetchIServiceTypeList();
  }, [fetchIServiceTypeList]);

  const iServiceTypeError = !!formState?.errors?.iServiceType;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} textAlign="end">
        <SwitchInput name="enable" label={t(translationPath + "enable")} />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormInput
          size="small"
          name="name"
          label={t(translationPath + "name")}
          fullWidth
        />
      </Grid>

      <MethodType />

      <Grid item xs={12}>
        <FormInput
          size="small"
          name="description"
          label={t(translationPath + "description")}
          multiline
          rows={4}
          fullWidth
        />
      </Grid>

      <Grid item xs={12}>
        <Box
          sx={(theme) => ({
            mt: 3,
            p: 3,
            border: `1px solid ${
              iServiceTypeError
                ? theme.palette.error.main
                : theme.palette.divider
            }`,
            borderRadius: 2,
          })}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography fontWeight="bold">
                {t(translationPath + "service")}
              </Typography>
            </Grid>

            <BusInternalTokenWrapper iServiceTypes={iServiceTypes} />

            {/* eslint-disable-next-line react/jsx-pascal-case */}
            <SI_PNIWrapper iServiceTypes={iServiceTypes} />
            <CertillionWrapper iServiceTypes={iServiceTypes} />
            <GerAcessoWrapper iServiceTypes={iServiceTypes} />
            <PlugNotasWrapper iServiceTypes={iServiceTypes} />
            <ShiftLISWrapper iServiceTypes={iServiceTypes} />
            <ProtheusWrapper iServiceTypes={iServiceTypes} />
            <SGUWrapper iServiceTypes={iServiceTypes} />

            {iServiceTypeError && (
              <Grid item xs={12} sm={12}>
                <Typography color="error" variant="body2">
                  {t(translationPath + "i_service_type_error")}
                </Typography>
              </Grid>
            )}
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
});
